export const IP_TEST = "https://www.cnbz.org.cn";
//nav
export const NAV_MODELS = [
  {
    id: "0",
    name: "网站首页",
    type: "home",
    path: '/'
  },
  {
    id: "1",
    name: "机构概况",
    type: "info",
    path: '/news/info/'
  },
  {
    id: "2",
    name: "信息公开",
    type: "view",
    path: '/news/views/'
  },
  {
    id: "3",
    name: "技术服务",
    type: "view",
    path: '/news/views/'
  },
  {
    id: "4",
    name: "教育培训",
    type: "view",
    path: '/news/views/'
  },
  {
    id: "5",
    name: "标准培训",
    type: "view",
    path: '/news/views/'
  },
  {
    id: "6",
    name: "资讯动态",
    type: "view",
    path: '/news/views/'
  },

  {
    id: "7",
    name: "联系我们",
    type: "info",
    path: '/news/info/'
  }
];
// NewsHot数据源
export const NEWS_HOT = ['通知公告'];
//InfoNews 数据源
export const INFO_NEWS = ['信息公开', '新闻动态'];
export const INFO_LIST = ['信用知识', '咨讯中心', '信用资讯'];
export const NEWS_LIST = ['通知公告', '标准化知识', '标准化要闻'];
export const PUBLIC_SERVICE = '公共服务';
//ad位置 位置F2
export const AD_POSITION = "位置F5";